import { render, staticRenderFns } from "./choiceContentBox.vue?vue&type=template&id=62200b48&scoped=true&"
import script from "./choiceContentBox.vue?vue&type=script&lang=js&"
export * from "./choiceContentBox.vue?vue&type=script&lang=js&"
import style0 from "./choiceContentBox.vue?vue&type=style&index=0&id=62200b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62200b48",
  null
  
)

export default component.exports